export default "__VITE_ASSET__BxRyd6gg__"